import React from 'react';

export default function LoveStory() {
  return (
    <section id="story" className="section">
      <span className="section-label animate-in">
        02 / The Story
      </span>

      <div
        style={{
          maxWidth: '800px',
          margin: '0 auto',
        }}
      >
        <h2
          className="section-title animate-in animate-in-delay-1"
          style={{ textAlign: 'center', marginBottom: '3rem' }}
        >
          A Tale of Passion,
          <br />
          Logic, and Side Hustles{' '}
          <span style={{ fontSize: '1.5rem' }}>🐍🤖🦀</span>
        </h2>

        <div
          className="glass-card animate-in animate-in-delay-2"
          style={{
            padding: '2.5rem 2rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.75rem',
          }}
        >
          {/* Python stanza */}
          <div
            style={{
              borderLeft: '2px solid #00ff88',
              paddingLeft: '1.25rem',
            }}
          >
            <p style={{ color: '#ccc', fontSize: '1rem', lineHeight: '1.9', margin: 0 }}>
              I speak the language of <strong style={{ color: '#00ff88' }}>serpents 🐍</strong>, working
              with them day by day. Among them, one has captured my heart —{' '}
              <strong style={{ color: '#00ff88' }}>Python</strong>, my true love, in every way.
            </p>
            <p style={{ color: '#aaa', fontSize: '0.95rem', lineHeight: '1.8', margin: 0, marginTop: '0.5rem', fontStyle: 'italic' }}>
              Each line of code was a symphony of logic and flair,
              <br />
              Simple, sweet, and elegant, beyond compare.
              <br />
              Python, you held my heart in the most profound way…
            </p>
          </div>

          {/* AI stanza — highlighted with cyan for AI elements */}
          <div
            className="glass-card"
            style={{
              borderLeft: '2px solid #00d4ff',
              paddingLeft: '1.25rem',
              padding: '1.5rem',
              background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.06), rgba(0, 212, 255, 0.02))',
              borderColor: 'rgba(0, 212, 255, 0.25)',
            }}
          >
            <p style={{ color: '#ccc', fontSize: '1rem', lineHeight: '1.9', margin: 0 }}>
              …And then the <strong style={{ color: '#00d4ff' }}>AI age</strong> arrived.{' '}
              <span style={{ fontSize: '1.1rem' }}>🤖</span>
            </p>
            <p style={{ color: '#aaa', fontSize: '0.95rem', lineHeight: '1.8', margin: 0, marginTop: '0.5rem', fontStyle: 'italic' }}>
              Now I spend my nights conversing with{' '}
              <strong style={{ color: '#00d4ff' }}>LLMs</strong> in the cloud,
              <br />
              Prompting, fine-tuning, shouting{' '}
              <span style={{ color: '#00d4ff', fontWeight: 600 }}>"Reason!"</span> out loud.
              <br />
              It's dynamic, it's thrilling, a brand-new affair —
              <br />
              Yet Python is still there, handling the <strong style={{ color: '#00d4ff' }}>pipelines</strong> with care.
            </p>

            {/* AI badge row */}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.6rem',
                marginTop: '1rem',
              }}
            >
              {['LLMs', 'Prompt Engineering', 'Fine-tuning', 'OpenAI', 'AI Pipelines'].map(
                (tag) => (
                  <span
                    key={tag}
                    style={{
                      display: 'inline-block',
                      padding: '0.25rem 0.75rem',
                      background: 'rgba(0, 212, 255, 0.1)',
                      border: '1px solid rgba(0, 212, 255, 0.2)',
                      borderRadius: '4px',
                      fontFamily: "'Inter', monospace",
                      fontSize: '0.72rem',
                      color: '#00d4ff',
                      letterSpacing: '0.04em',
                    }}
                  >
                    {tag}
                  </span>
                )
              )}
            </div>
          </div>

          {/* Rust stanza */}
          <div
            style={{
              borderLeft: '2px solid #ff6b35',
              paddingLeft: '1.25rem',
            }}
          >
            <p style={{ color: '#ccc', fontSize: '1rem', lineHeight: '1.9', margin: 0 }}>
              And off to the side? <span style={{ fontSize: '1.1rem' }}>🦀</span>{' '}
              <strong style={{ color: '#ff6b35' }}>Rust</strong> is my secret sidekick,
              strict and ultra-fast, yelling at my memory, forcing borrow checks to pass.
            </p>
            <p style={{ color: '#aaa', fontSize: '0.95rem', lineHeight: '1.8', margin: 0, marginTop: '0.5rem', fontStyle: 'italic' }}>
              No garbage collection, zero-overhead thrill,
              <br />
              It hurts so good, but man, what a speed-boost skill!
            </p>
          </div>

          {/* Closing */}
          <div
            style={{
              textAlign: 'center',
              paddingTop: '0.5rem',
              borderTop: '1px solid rgba(255, 255, 255, 0.06)',
            }}
          >
            <p style={{ color: '#ddd', fontSize: '1rem', lineHeight: '1.9', margin: 0 }}>
              So here I stand:
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '1.5rem',
                flexWrap: 'wrap',
                marginTop: '0.75rem',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '0.7rem', color: '#00d4ff', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.25rem' }}>
                  Top Tier
                </div>
                <span
                  style={{
                    display: 'inline-block',
                    padding: '0.35rem 0.9rem',
                    background: 'rgba(0, 212, 255, 0.1)',
                    border: '1px solid rgba(0, 212, 255, 0.2)',
                    borderRadius: '4px',
                    fontSize: '0.85rem',
                    color: '#00d4ff',
                    fontWeight: 600,
                  }}
                >
                  Prompts 🤖
                </span>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '0.7rem', color: '#00ff88', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.25rem' }}>
                  The Core
                </div>
                <span
                  style={{
                    display: 'inline-block',
                    padding: '0.35rem 0.9rem',
                    background: 'rgba(0, 255, 136, 0.1)',
                    border: '1px solid rgba(0, 255, 136, 0.2)',
                    borderRadius: '4px',
                    fontSize: '0.85rem',
                    color: '#00ff88',
                    fontWeight: 600,
                  }}
                >
                  Python 🐍
                </span>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '0.7rem', color: '#ff6b35', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.25rem' }}>
                  Engine Room
                </div>
                <span
                  style={{
                    display: 'inline-block',
                    padding: '0.35rem 0.9rem',
                    background: 'rgba(255, 107, 53, 0.1)',
                    border: '1px solid rgba(255, 107, 53, 0.2)',
                    borderRadius: '4px',
                    fontSize: '0.85rem',
                    color: '#ff6b35',
                    fontWeight: 600,
                  }}
                >
                  Rust 🦀
                </span>
              </div>
            </div>
            <p style={{ color: '#999', fontSize: '0.9rem', lineHeight: '1.8', margin: 0, marginTop: '1.5rem', fontStyle: 'italic' }}>
              And I've at least learnt something, I think… 🤷‍♂️
            </p>
          </div>
        </div>

        {/* GitHub Contributions Snake */}
        <div className="animate-in animate-in-delay-3" style={{ marginTop: '3rem' }}>
          <span className="section-label">🐍 My Love Eating My Contributions</span>
          <div
            className="glass-card"
            style={{
              padding: '1.5rem',
              overflow: 'hidden',
            }}
          >
            <img
              style={{ width: '100%', display: 'block' }}
              alt="snake eating my contributions"
              src="https://raw.githubusercontent.com/Balaji2810/Balaji2810/output/github-contribution-grid-snake-dark.svg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}